import React from "react";
import { Route, BrowserRouter } from "react-router-dom";

import ErrorCodeMapping from "./pages/ErrorCodeMapping";

const Routes = () => {
  return (
    <BrowserRouter>
      <Route component={ErrorCodeMapping} path="/" exact />
    </BrowserRouter>
  );
};

export default Routes;
